import React from"react";import{Combobox}from"@headlessui/react";export const ComboboxGeneric=props=>React.createElement(Combobox,props);